import {apiback} from '../../../../../config';
import {Sync} from 'MWC';

const hashData = {
    'become a partner': '546B0B5BC97BE94B',
    default: '656S0B5BC97B3360'
};

export default {
    activeScreen: '',
    sendForm: async function(data) {
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        tel: data.phone,
                        user: data.name,
                        mail: data.email,
                        name: data.city,
                        okpo: data.okpo,
                        utmMarks: data.utmMarks,
                        ...(data.attribute === 'become a partner' && {
                            attribute: data.attribute
                        })
                    },
                    hash: hashData[data.attribute] || hashData.default
                },
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                this.activeScreen = 'success';
            }
        } catch (error) {
            this.activeScreen = 'error';
            return error;
        }
    }
};
